module.exports = __webpack_public_path__ + "static/media/CessnaC421GoldenEagle.81da919a.png";